(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .service('SalesFunnelService', SalesFunnelService);

    /** @ngInject */
    function SalesFunnelService(SalesFunnelFactory) {
        var service = this;

        service.getCardWall = function(filter) {
            return SalesFunnelFactory.getCardWall(filter).$promise;
        };

        service.addStage = function (stage) {
            return SalesFunnelFactory.addStage(stage).$promise;
        };

        service.updateStage = function (stageId, updatedStage) {
            return SalesFunnelFactory.updateStage({ stageId: stageId }, updatedStage).$promise;
        };

        service.deleteStage = function (stageId) {
            return SalesFunnelFactory.deleteStage({ stageId: stageId }).$promise;
        };

        service.getNegotiation = function (negotiationId) {
            return SalesFunnelFactory.getNegotiation({ negotiationId: negotiationId }).$promise;
        }

        service.addNegotiation = function (negotiation) {
            return SalesFunnelFactory.addNegotiation(negotiation).$promise;
        };

        service.updateNegotiation = function (negotiationId, updatedNegotiation) {
            return SalesFunnelFactory.updateNegotiation({id: negotiationId }, updatedNegotiation).$promise;
        };

        service.updateNegotiationStage = function (negotiationId, updatedNegotiation) {
            return SalesFunnelFactory.updateNegotiationStage({id: negotiationId }, updatedNegotiation).$promise;
        };

        service.deleteNegotiation = function (negotiationId) {
            return SalesFunnelFactory.deleteNegotiation({ negotiationId: negotiationId }).$promise;
        };

        service.loadNegotiations = function (stageId, offset) {
            return SalesFunnelFactory.loadNegotiations({ stageId: stageId, offset: offset }).$promise;
        };
    }
})();
